import React from 'react';
import * as ReactQuery from '@tanstack/react-query';
import { ChildrenInterface } from '../types';

const queryClient = new ReactQuery.QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity, // Change to milliseconds in case you want to refetch data in the background
      cacheTime: Infinity, // Change to milliseconds in case you want to garbage collect unused data
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const ServiceProvider: React.FC<ChildrenInterface> = ({ children }) => (
  <ReactQuery.QueryClientProvider client={queryClient}>
    {children}
  </ReactQuery.QueryClientProvider>
);
